import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { Skeleton } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';

export function SlotPickerSkeleton() {
  const { textColor } = useSettings();
  const color = getColorWithAlpha(textColor, 0.05);

  const labelProps = {
    color,
    borderRadius: 0
  };
  const dayBtnProps = {
    color,
    borderRadius: 8,
    width: 150,
    height: 66
  };
  const timeBtnProps = {
    color,
    borderRadius: 8,
    width: 100,
    height: 44
  };

  return (
    <Flex _gap={20}>
      <Flex _gap={20}>
        <Flex
          _direction="row"
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
            maxHeight: 22
          }}
        >
          <Skeleton {...labelProps} width={120} height={22} />
          <Skeleton {...labelProps} width={64} height={32} />
        </Flex>

        <Flex _direction="row" _gap={4}>
          <Skeleton {...dayBtnProps} />
          <Skeleton {...dayBtnProps} />
          <Skeleton {...dayBtnProps} />
          <Skeleton {...dayBtnProps} />
          <Skeleton {...dayBtnProps} />
          <Skeleton {...dayBtnProps} />
          <Skeleton {...dayBtnProps} />
        </Flex>
      </Flex>

      <Flex _gap={20}>
        <Flex _gap={8}>
          <Skeleton {...labelProps} width={46} height={16} />
          <Flex _direction="row" _gap={4}>
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
          </Flex>
        </Flex>

        <Flex _gap={8}>
          <Skeleton {...labelProps} width={55} height={16} />
          <Flex _direction="row" _gap={4}>
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
          </Flex>
        </Flex>

        <Flex _gap={8}>
          <Skeleton {...labelProps} width={44} height={16} />
          <Flex _direction="row" _gap={4}>
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
            <Skeleton {...timeBtnProps} />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

const Flex = styled.div<{
  _direction?: 'column' | 'row';
  _gap?: number;
  _wrap?: boolean;
}>`
  display: flex;
  flex-direction: ${({ _direction = 'column' }) => _direction};
  flex-wrap: ${({ _wrap = false }) => (_wrap ? 'wrap' : 'nowrap')};
  gap: ${({ _gap = 4 }) => _gap}px;
`;
